import {useRefreshUser, useUser} from '@gaia/stores/user';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {useState} from 'react';
import useSWRImmutable from 'swr/immutable';

export default function useRequestFreeTrial() {
    const {id} = useUser();
    const refreshUser = useRefreshUser();

    const [sendFreeTrialRequest, setSendFreeTrialRequest] = useState<boolean>(false);

    const {data: wasFreeTrialActivated, error} = useSWRImmutable(
        sendFreeTrialRequest ? `free-trial-${id}` : null,
        async () => {
            const response = await fetch('/api/user/v2/subscription/request-trial/', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    subscription_plan_identifier: '1WeekPremiumTrial',
                }),
            });
            if (response.ok) {
                ampli.startTrial({trialIdentifier: 'trial97'});
            }
            return response.ok;
        }
    );

    const isTrialRequestProcessing =
        sendFreeTrialRequest && wasFreeTrialActivated === undefined && error === undefined;

    if (wasFreeTrialActivated) refreshUser();

    return {
        isTrialRequestProcessing,
        wasFreeTrialActivated,
        requestFailureMessage: error
            ? 'Something went wrong. Please try again.'
            : 'Your account is ineligible for a free trial. Please contact support.',
        requestFreeTrial: () => setSendFreeTrialRequest(true),
    };
}
